import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function ProductDetails() {
  const { id } = useParams();
  const [elem,setData] = useState({});
  useEffect(() => {
    fetch(
      `https://dbioz2ek0e.execute-api.ap-south-1.amazonaws.com/mockapi/get-products/${id}`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setData(data.data);
      });
  }, []);
  return (
    <div>
      <img src={elem.image} alt="image" />
      <h3>{elem.title}</h3>
      <p>{elem.brand}</p>
      <p>{elem.category}</p>
      <p>{elem.price}</p>
    </div>
  );
}

export default ProductDetails;
